/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_4_TitleInputs */

const en_pc_rv_4_title = /** @type {(inputs: Pc_Rv_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where the alpha shows`)
};

const zh_pc_rv_4_title = /** @type {(inputs: Pc_Rv_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha 的短板`)
};

/**
* | output |
* | --- |
* | "Where the alpha shows" |
*
* @param {Pc_Rv_4_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_4_title = /** @type {((inputs?: Pc_Rv_4_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_4_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_4_title(inputs)
	return zh_pc_rv_4_title(inputs)
});
export { pc_rv_4_title as "pc.rv.4.title" }